import React, { FunctionComponent, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faPlus, faTasks } from '@fortawesome/free-solid-svg-icons';
import customer_logo from './../algospark-symbol-dark-blue.svg';
import { useLocation } from 'react-router-dom';
import { OrganizationSwitcher, UserButton } from '@clerk/clerk-react';
import { clerkVariables } from '../variables/clerk';
import { useNavigateWithinOrg } from '../utils/navigation';
import useURLParams from '../hooks/useURLParams';
import { useModalContext } from '../contexts/ModalContext';

const NavBar: FunctionComponent = () => {
    const location = useLocation();
    const modalButtonRef = useRef<HTMLButtonElement>(null);

    const isActive = (path: string) => location.pathname.endsWith(path);

    const navigate = useNavigateWithinOrg();
    const { setModalText } = useModalContext();

    return (
        <div className="navbar-wrapper">
            <div className="navbar">
                <div className="upper-container">
                    <img
                        src={customer_logo}
                        alt="Brand logo"
                        className="brand-logo"
                    />
                    {/* Label Checker */}
                    <nav className="nav-menu">
                        {/* <div style={{ position: 'relative' }}>
                            <button
                                className="nav-button add"
                                onClick={() => {
                                    navigate('/projects');
                                    setParam('modal', 'create');
                                }}
                                ref={modalButtonRef}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </div> */}
                        <button
                            onClick={() => {
                                navigate('/projects');
                            }}
                            className={`nav-button ${
                                isActive('/projects') ? 'selected' : ''
                            }`}
                        >
                            <FontAwesomeIcon icon={faBook} />
                        </button>
                        <button
                            onClick={() => {
                                setModalText({
                                    title: 'Analytics Is Coming Soon',
                                    text: 'This feature will launch in February 2025. It will help you track key metrics such as approval percentage, review count, and more to provide valuable insights.',
                                });
                            }}
                            className={`nav-button ${
                                isActive('/library') ? 'selected' : ''
                            }`}
                        >
                            <FontAwesomeIcon icon={faTasks} />
                        </button>
                    </nav>
                </div>
                <div className="lower-container">
                    {/* <Protect condition={(has) => has({ role: 'org:admin' })}>
                        {organization && ( */}
                    <OrganizationSwitcher
                        hidePersonal
                        afterSelectOrganizationUrl="/"
                        appearance={{
                            variables: clerkVariables,
                            elements: {
                                avatarBox: {
                                    width: '26px',
                                    height: '26px',
                                },
                                organizationPreviewMainIdentifier: 'hidden',
                                organizationSwitcherTriggerIcon: 'hidden',
                            },
                        }}
                        organizationProfileProps={{
                            appearance: {
                                variables: clerkVariables,
                            },
                        }}
                    />
                    {/* )}
                    </Protect> */}
                    {/* <OrganizationSwitcher hidePersonal>
                        <OrganizationSwitcher.OrganizationProfilePage
                            label="Custom Page"
                            url="custom"
                            labelIcon={<BuildingIcon />}
                        >
                            <div>
                                <h1>Custom Organization Profile Page</h1>
                                <p>
                                    This is the custom organization profile page
                                </p>
                            </div>
                        </OrganizationSwitcher.OrganizationProfilePage>

                        <OrganizationSwitcher.OrganizationProfilePage
                            label="Terms"
                            labelIcon={<BuildingIcon />}
                            url="terms"
                        >
                            <OrganizationList hidePersonal />
                        </OrganizationSwitcher.OrganizationProfilePage>
                    </OrganizationSwitcher> */}
                    {/* <OrganizationList hidePersonal /> */}
                    <UserButton
                        appearance={{
                            variables: clerkVariables,
                            elements: {
                                // rootBox: {
                                //     marginLeft: '15px',
                                // },
                                avatarBox: {
                                    width: '28px',
                                    height: '28px',
                                },
                            },
                        }}
                        userProfileProps={{
                            appearance: {
                                variables: clerkVariables,
                            },
                        }}
                    >
                        {/* <UserButton.MenuItems>
                            <Protect
                                condition={(has) => has({ role: 'org:admin' })}
                            >
                                {organization && (
                                    <UserButton.Action
                                        label={`Manage ${organization.name}`}
                                        labelIcon={<BuildingIcon />}
                                        onClick={() => navigate('/test')}
                                    />
                                )}
                            </Protect>

                            <UserButton.Action
                                label="Change Organization"
                                labelIcon={<BuildingIcon />}
                                onClick={() => navigate('/orgs')}
                            />
                        </UserButton.MenuItems> */}
                    </UserButton>
                </div>
            </div>
            {/* <OrganizationProfile /> */}
        </div>
    );
};

export default NavBar;
